/**
 * Device File API Types
 * @description デバイスファイルAPI関連の型定義
 */

import type { ApiRequestBody, ApiResponseBody, ApiSearchQuery } from '@/lib/api/api-type-helper';

// ============================================
// Response Types
// ============================================

export type FindDeviceFilesResponse = ApiResponseBody<'/v2/devices/{id}/files', 'get'>;

// ============================================
// Request Types
// ============================================

export type FindDeviceFilesQuery = ApiSearchQuery<'/v2/devices/{id}/files', 'get'>;

/**
 * ソートカラムの定数オブジェクト（OpenAPI型定義から抽出）
 * @description marketplace等の標準パターンに準拠
 */
export const DeviceFileSortColumn = {
  FILE_NAME: 'fileName',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt'
} as const satisfies Record<string, NonNullable<FindDeviceFilesQuery['orderBy']>>;

/**
 * ソートカラムの型
 */
export type DeviceFileSortColumn = (typeof DeviceFileSortColumn)[keyof typeof DeviceFileSortColumn];
export type CreateDeviceFileRequest = ApiRequestBody<'/v2/devices/{id}/files', 'post'>;
export type UpdateDeviceFileRequest = ApiRequestBody<'/v2/devices/{deviceId}/files/{fileId}', 'patch'>;

// ============================================
// Domain Types
// ============================================

export type DeviceFolderType = 'INSTALLATION' | 'RETRIEVAL' | 'ASSIGNMENT' | 'RETURN' | 'RECEIVING' | 'INITIAL_SETUP' | 'INVENTORY' | 'REPAIR' | 'REPLACEMENT' | 'DISPOSAL' | 'DOCUMENT';

/**
 * UI表示用のPerson型
 * @description PersonCellで使用するためにidフィールドを持つ
 */
export type PersonItem = {
  id: string;
  name: string | null;
  email: string | null;
  avatarUrl: string | null;
};

/**
 * デバイスファイル一覧の行データ型
 * @description テーブル表示用のデータ構造
 */
export type DeviceFileItem = {
  id: string;
  fileName: string;
  mimeType: string;
  fileUrl: string;
  folderType: DeviceFolderType;
  createdAt: string;
  updatedAt: string;
  createdByPerson: PersonItem | null;
  updatedByPerson: PersonItem | null;
};
export type DeviceFileTableRow = DeviceFileItem;